import React from "react";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import {dashBoardStyle} from "features/Dashboard/components/dashBoardStyle";
import NotificationImportantOutlinedIcon from "@mui/icons-material/NotificationImportantOutlined";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import {useAppSelector} from "../../../../redux/store";
import {Link} from "react-router-dom";
import Skeleton from "@mui/material/Skeleton";
import Grid from "@mui/material/Grid";
import {
  Alerts,
  AxiosErrorCode,
  CPSConstants,
  CPSMessages,
  HttpStatusCode,
  PageNames,
} from "commonUtils/enumerations";
import {
  HttpException,
  ServiceAuthenticationException,
} from "services/exceptionHandlerService";
import FormValidationAlert from "components/FormComponents/Alert/FormValidationAlert";
import {logMessage} from "services/loggerService";
import "../../../Dashboard/Dashboard.css";

const DashboardAlert: React.FC<any> = alertsData => {
  const [errorMsg, setErrorMsg] = React.useState<string>("");

  const {userDetails} = useAppSelector(state => {
    return state.auth;
  });

  const handleOpenAlertLink = (event: any) => {
    try {
      logMessage(
        "INFO",
        `User ${userDetails?.userName} had opened the Alert Link ${event.currentTarget}.`,
        PageNames.DASHBOARD,
      );
    } catch (error: any) {
      handleAxiosErrors(error);
    }
  };

  const handleAxiosErrors = (error: any) => {
    const data = {pagename: PageNames.DASHBOARD};
    if (error?.code === AxiosErrorCode.ERR_BAD_REQUEST) {
      if (
        error?.response?.status === HttpStatusCode.UNAUTHORIZED ||
        error?.response?.status === HttpStatusCode.FORBIDDEN
      ) {
        ServiceAuthenticationException(error, data, error?.response?.status);
      } else if (error?.response?.status === HttpStatusCode.BAD_REQUEST) {
        setErrorMsg(error.response.data.message);
      } else if (error?.response?.status === HttpStatusCode.NOT_FOUND) {
        setErrorMsg(CPSMessages.SERVICE_NOT_FOUND);
      } else if (
        error?.response?.status === HttpStatusCode.INTERNAL_SERVER_ERROR
      ) {
        HttpException(error, data);
        setErrorMsg(CPSMessages.INTERNAL_SERVER_ERROR);
      } else {
        setErrorMsg(error.message);
      }
    } else if (error?.code === AxiosErrorCode.ECONNABORTED) {
      setErrorMsg(CPSMessages.TIMEOUT_ERROR);
    } else if (error?.code === AxiosErrorCode.ERR_NETWORK) {
      setErrorMsg(CPSMessages.NETWORK_ERROR);
    } else {
      setErrorMsg(error.message);
    }
  };

  const totalAlertCount: number = alertsData?.alertsData?.reduce(
    (acc: number, {alertCount}: {alertCount: number}) => acc + alertCount,
    0,
  );

  return (
    <>
      {errorMsg && (
        <FormValidationAlert severity={Alerts.ERROR} message={errorMsg} />
      )}
      {alertsData?.alertsData !== undefined &&
      Object.keys(alertsData?.alertsData).length !== 0 &&
      alertsData?.alertsData !== null ? (
        <Paper className="paper-look">
          <Typography component="div" className="alert-heading">
            <NotificationImportantOutlinedIcon className="outline-icon" />
            {"Alerts" +
              " ( " +
              (Object.keys(alertsData?.alertsData).length !== 0
                ? totalAlertCount
                : "0") +
              " )"}
          </Typography>
          <Box className="my-border" />
          <Box className="box-padding-bottom" />
          <List className="my-list">
            <ListItem alignItems="flex-start">
              <ListItemText
                key={-1}
                primary={
                  <>
                    <Typography component="p" className="types">
                      Type
                    </Typography>
                  </>
                }
              />
              <Typography component="p" className="numbers">
                Number
              </Typography>
            </ListItem>
          </List>
          <List className="my-list dashboard-alert-block">
            {Object.keys(alertsData?.alertsData).length !== 0 ||
            alertsData?.alertsData?.length !== undefined ? (
              alertsData?.alertsData?.map((row: any, index: number) => (
                <>
                  <ListItem
                    key={index}
                    className="display-flex align-items-center">
                    <ListItemText
                      key={index}
                      primary={
                        <>
                          <Link
                            onClick={handleOpenAlertLink}
                            to={`/alerts/${row.pageToLoad}`}>
                            <Typography component="p" className="alert-name">
                              {row.alertName}
                            </Typography>
                          </Link>
                        </>
                      }
                    />
                    <Typography component="p" className="alert-count">
                      {row.alertCount}
                    </Typography>
                  </ListItem>
                </>
              ))
            ) : (
              <Box height={"15rem"}>
                <Grid container spacing={2} m={"-2rem"}>
                  <Grid item xs={11}>
                    <Skeleton variant="text" />
                  </Grid>
                  <Grid item xs={1}>
                    <Skeleton variant="text" />
                  </Grid>
                  <Grid item xs={11}>
                    <Skeleton variant="text" />
                  </Grid>
                  <Grid item xs={1}>
                    <Skeleton variant="text" />
                  </Grid>
                  <Grid item xs={11}>
                    <Skeleton variant="text" />
                  </Grid>
                  <Grid item xs={1}>
                    <Skeleton variant="text" />
                  </Grid>
                  <Grid item xs={11}>
                    <Skeleton variant="text" />
                  </Grid>
                  <Grid item xs={1}>
                    <Skeleton variant="text" />
                  </Grid>
                </Grid>
              </Box>
            )}
          </List>
        </Paper>
      ) : (
        <Paper className="paper-look">
          <Typography component="div" className="alert-heading">
            <NotificationImportantOutlinedIcon className="outline-icon" />
            {"Alerts" + " ( " + "0" + " )"}
          </Typography>
          <Box className="my-border" />
          <Box className="box-padding-bottom" />
          <List className="my-list">
            <ListItem className="display-flex align-items-center">
              <ListItemText
                key={-1}
                primary={
                  <>
                    <Typography component="p" className="types">
                      Type
                    </Typography>
                  </>
                }
              />
              <Typography component="p" className="numbers">
                Number
              </Typography>
            </ListItem>
          </List>
          <List className="recordsnotfound">
            {CPSMessages.DASHBOARDALERTNODATA}
          </List>
        </Paper>
      )}
    </>
  );
};
export default DashboardAlert;
